
import { Button } from 'element-ui';
export default {
  computed: {
    loyaltyLink() {
      let link = this.localePath({ name: `account-loyalty-membership` });
      if (!this.$auth.loggedIn) {
        return this.localePath({
          name: 'authenticate-route',
          params: {
            route: 'login',
          },
          query: {
            redirect: 'account-loyalty-membership',
          },
        });
      }
      return link;
    },
  },
  components: {
    Button,
  },
};
